import { render, staticRenderFns } from "./admtiendas.vue?vue&type=template&id=090a8ec8&scoped=true&"
import script from "./admtiendas.vue?vue&type=script&lang=js&"
export * from "./admtiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a8ec8",
  null
  
)

export default component.exports